import { motion } from "framer-motion";

const chapters = [
  {
    tag: "Il proprietario",
    title: "Affittare non deve essere un secondo lavoro",
    text: "Il canone che non arriva. Il danno da ripagare. La casa che non si libera. La burocrazia che non finisce mai. Se possiedi un immobile, conosci già quest'ansia: noi esistiamo per cancellarla.",
  },
  {
    tag: "L'inquilino",
    title: "Chi cerca casa cerca fiducia, non ostacoli",
    text: "Costi iniziali altissimi, nessun supporto, porte che si chiudono. Anche l'inquilino migliore parte svantaggiato: per questo lo selezioniamo, lo tuteliamo e lo facciamo sentire a casa.",
  },
  {
    tag: "La soluzione",
    title: "Semplificaffitto.it — Takes Care!",
    text: "Un sistema nato per proteggere la rendita di chi possiede e la serenità di chi abita. La tua casa in affitto, finalmente, rende felici entrambi. E tu incassi, ogni mese, senza pensieri.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="bg-paper py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="eyebrow text-brandblue mb-6"
        >
          Il manifesto
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-3xl leading-[1.12]"
        >
          Prendersi cura. <span className="text-brandblue italic">Di entrambi.</span>
        </motion.h2>

        <div className="mt-16 lg:mt-24 border-t border-ink/10">
          {chapters.map((c, i) => (
            <motion.div
              key={c.tag}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 lg:py-14 border-b border-ink/10 items-start"
              data-testid={`manifesto-chapter-${i + 1}`}
            >
              <span className="md:col-span-3 eyebrow text-azure pt-2 group-hover:tracking-[0.4em] transition-[letter-spacing] duration-500">
                {c.tag}
              </span>
              <h3 className="md:col-span-4 font-serif font-semibold text-2xl lg:text-3xl leading-tight">{c.title}</h3>
              <p className="md:col-span-5 text-base lg:text-lg text-ink/65 leading-relaxed">{c.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
